import { TEXT } from "~/constants/text";

/**
 * メッセージの表示テキストを解決する共通ロジック。
 * メッセージ一覧・メッセージ詳細・アプリ内通知の3箇所で使用する。
 */
export const resolveMessagePreview = (
  content: string | null,
  msgType: string | undefined,
  isOwn: boolean,
): string => {
  if (content === null) return "";
  if (content === "キャンセル" || content === "Cancel") {
    return isOwn ? TEXT.chat.room.callCancelled : TEXT.chat.room.missedCall;
  }
  if (msgType === "EVIDEO") return "";
  if (msgType === "STK") {
    return isOwn ? TEXT.chat.list.stickerSent : TEXT.chat.list.stickerReceived;
  }
  if (msgType === "ABSENCECALL") {
    if (content.includes("|")) return TEXT.chat.room.callEnded;
    return isOwn ? TEXT.chat.room.callCancelled : TEXT.chat.room.missedCall;
  }
  if (content.includes("|p|")) {
    return isOwn ? TEXT.chat.list.imageSent : TEXT.chat.list.imageReceived;
  }
  if (content.includes("|v|")) {
    return isOwn ? TEXT.chat.list.videoSent : TEXT.chat.list.videoReceived;
  }
  if (content.includes("|a|")) {
    return isOwn ? TEXT.chat.list.audioSent : TEXT.chat.list.audioReceived;
  }
  return content;
};
